module.exports = __webpack_public_path__ + "media/flags/cz-flag-4c9a5a77.svg";